import tooltips from './parameter-tooltips.json';

/**
 * Returns narrative tooltip text for a parameter alias.
 * 
 * Resolution order:
 * 1. Exact match against the JSON map.
 * 2. Fallback: return the first entry whose alias ends with `'.' + key`  
 *    (e.g. asking for `strength` finds `gravity.strength`).
 */
export const getTooltip = (key) => {
  if (!key) return '';

  // 1. Direct hit
  if (tooltips[key]) return tooltips[key];

  // 2. Suffix fallback – match the longest candidate that ends with "." + key
  const suffix = `.${key}`;
  const match = Object.keys(tooltips).find(k => k.endsWith(suffix));
  return match ? tooltips[match] : '';
}; 